import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public listTitles: any[];
  public location: Location;
  is_connected: boolean = false;
  avatar: any;
  full_name: string = "";
  constructor(location: Location, private element: ElementRef, private router: Router, private authService: AuthService) {
    this.location = location;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    
    this.authService.currentUserSubject.subscribe((currentUserValue) => {
      this.is_connected = currentUserValue != null;
      this.avatar = this.is_connected
        ? currentUserValue.profile.thumbnail
        : this.avatar;
      this.full_name = this.is_connected
      ? currentUserValue.profile.full_name
      : ""; 

    });
    //this.url_edit_profile = "/profiles/edit/" + this.authService.currentUserValue.profile.id.toString();
  }
  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  logout() {
    this.authService.logout();

  }

}
